import { createAction } from 'lib/store-utils';
import { ProjectsActionPayload } from './types';

export const GET_PROJECTS_REQUEST = createAction('Get projects request');
export const UPDATE_PROJECTS = createAction<ProjectsActionPayload>(
  'Update project data'
);
